import React, { createContext, useEffect, useState } from 'react'

const StoreContext = createContext({})

const StoreProvider = (props) => {

    // Client Info
    const [clientInfo, setClientInfo] = useState(JSON.parse(sessionStorage.getItem('clientInfo')) || {
        UID: 0,
        Name: "",
        Phone: "",
        Email: "",
        Address: "",
        Apt: "",
        City: "",
        ZipCode: "",
        Notes: "",
        Pickup: "",
        DiningOption: "",
        DiningView: "",
    })

    const [location, setLocation] = useState("")
    const [language, setLanguage] = useState("fr")
    const [dining, setDining] = useState(clientInfo.DiningOption)
    const [diningView, setDiningView] = useState(clientInfo.DiningView)

    const [store, setStore] = useState([])
    const [menu, setMenu] = useState([])

    let linkStore = process.env.REACT_APP_API_URL + location + "/store.json"
    let linkMenu  = process.env.REACT_APP_API_URL + location + "/menu.json"

    let sessionStore = JSON.parse(sessionStorage.getItem(location + "_Store"))
    let sessionMenu  = JSON.parse(sessionStorage.getItem(location + "_Menu"))

    // Ping POS if is ONLINE or NOT
    //*PING|CLIENT_KEY|<EOF>

    const fetchData = async () => {

        if (location !== "") {

            if (sessionStore) {
                setStore(sessionStore)
            } else {
                try {
                    const data = await fetch(linkStore)
                    const Store = await data.json()
                    setStore(Store)
                    sessionStorage.setItem(location + "_Store", JSON.stringify(Store))
                } catch (e) {
                    if (e) {
                        console.log(e.message, 'Cannot load store info')
                    }
                }
            }

            if (sessionMenu) {
                setMenu(sessionMenu)
            } else {
                try {
                    const data = await fetch(linkMenu)
                    const Menu = await data.json()
                    setMenu(Menu)
                    sessionStorage.setItem(location + "_Menu", JSON.stringify(Menu))
                } catch (e) {
                    if (e) {
                        console.log(e.message, 'Cannot load menu info')
                    }
                }
            }
        }
    }

    useEffect(() => {
        fetchData()
    }, [location]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <StoreContext.Provider value={{
            setLocation,
            setLanguage,
            setDining,
            dining,
            setDiningView,
            diningView,
            clientInfo,
            setClientInfo,
            store,
            menu,
            language
        }}>
            {props.children}
        </StoreContext.Provider>
    )
}

export { StoreContext, StoreProvider }